/**
 * Tour de France 2026 – Owl Carousel Sliders
 *
 * All carousel initializations in one place.
 */

/* global jQuery */

(function ($) {
    'use strict';

    function initSliders() {
        if (!$.fn.owlCarousel) {
            $(window).on('load', function () {
                initSliders();
            });
            return;
        }

        // ── People slider: .tdf26-os-people__inner ──
        // Infinite, dots only, responsive 1/2/3 items
        var navSvgRight = '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none"><circle cx="31" cy="31" r="31" transform="matrix(-1 0 0 1 62 0)" fill="#007A33"/><path d="M25 18.5L37.5 31L25 43.5" stroke="white" stroke-width="2"/></svg>';
        var navSvgLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none" style="transform:scaleX(-1)"><circle cx="31" cy="31" r="31" transform="matrix(-1 0 0 1 62 0)" fill="#007A33"/><path d="M25 18.5L37.5 31L25 43.5" stroke="white" stroke-width="2"/></svg>';

        $('.tdf26-os-people__inner').each(function () {
            $(this).addClass('owl-carousel').owlCarousel({
                loop: true,
                nav: true,
                navText: [navSvgLeft, navSvgRight],
                dots: true,
                margin: 20,
                responsive: {
                    0:    { items: 1 },
                    600:  { items: 2 },
                    1024: { items: 3 }
                }
            });
        });

        // ── Tickets listing: .tdf26-tickets-listing ──
        // 1 item on mobile (carousel), 2 items on desktop (grid-like, no drag)
        /* $('.tdf26-tickets-listing').each(function () {
            $(this).addClass('owl-carousel').owlCarousel({
                loop: false,
                nav: false,
                dots: true,
                mouseDrag: true,
                touchDrag: true,
                margin: 50,
                responsive: {
                    0:    { items: 1 },
                    1024: { items: 2, dots: false, mouseDrag: false, touchDrag: false }
                }
            });
        }); */

        // ── Single-item slider: .tdf26-slide ──
        // Infinite, dots only, 1 item per row
        $('.tdf26-slider').each(function () {
            $(this).addClass('owl-carousel').owlCarousel({
                loop: true,
                nav: true,
                dots: true,
                items: 1,
                navText: [navSvgLeft, navSvgRight],
            });
        });
    }

    if ($('body').hasClass('tdf_2026')) {
        initSliders();
    }
})(jQuery);
